import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ColumnsService } from './columns.service';
import { ColumnsRequest } from './dto/column-request';
import { ColumnsDTO } from './dto/columns.dto';
import { columnByIdDto } from './dto/columns_dto';
import {CreateColumnsResponseModel,AllColumnsResponseModel,ColumnsResponseModel,ColumnResponse,ColumnDto, ColumnsDropDownResponseModel, ColumnDropDownDto} from '@gtpl/shared-models/masters'
import { ColumnsDtoActive } from './dto/columns_active_inactive';
import { ZoneRackLevelByIdDto } from './dto/zoneId-request-dto';
import { Columns } from './colunms.entity';
@ApiTags('columns')
@Controller('columns')
export class ColumnsController {
    constructor(private columnsService: ColumnsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    
      @Post('/createColumns')
      async createColumns(@Body() columnsDto: ColumnsDTO): Promise<CreateColumnsResponseModel>  {
        try {
          return await this.columnsService.CreateColumns(columnsDto, false);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(CreateColumnsResponseModel, error);
        }
      }
    
    
      @Post('/updateColumns')
      async updateColumns(@Body() columnsDto: ColumnsDTO): Promise<CreateColumnsResponseModel>  {
        try {
          return await this.columnsService.CreateColumns(columnsDto, true);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(CreateColumnsResponseModel, error);
        }
      }
    
    
      @Post('getRecordByColumnsId')
      async getRecordByColumnsId(@Body() id: columnByIdDto): Promise<ColumnsResponseModel> {
        try {
          return await this.columnsService.getRecordByColumnsId(id.columnsId);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(ColumnsResponseModel, error);
        }
      }
      @Post('getAllColumns')
      async getAllColumns():Promise<AllColumnsResponseModel> {
        try {
          return await this.columnsService.getAllColumns();
        } catch (error) {
          return this.applicationExceptionHandler.returnException(AllColumnsResponseModel, error);
        }
      }
      @Post('activateorDeactivateColumn')
      async activateorDeactivateColumn(@Body() ColumnAct: ColumnsDtoActive):Promise<ColumnResponse> {
        try {
          return await this.columnsService.activateorDeactivateColumn(ColumnAct);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(ColumnResponse, error);
        }
      }
      @Post('/updateRack')
       async updateRack(@Body() columnsDto:ColumnsDTO,isUpdate:boolean=true): Promise<ColumnsResponseModel> {
           try {
            return await this.columnsService.CreateColumns(columnsDto,true);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(ColumnsResponseModel, error);
          }
        }
        @Post('/getAllColumnDropDown')
        async getAllColumnDropDown(): Promise<ColumnsDropDownResponseModel> {
            try {
             return await this.columnsService.getAllColumnDropDown();
           } catch (error) {
                return this.applicationExceptionHandler.returnException(ColumnsDropDownResponseModel, error);
           }
         }
    
         @Post('/getColumnById')
         async getColumnById(@Body() columnsreq: ColumnsRequest): Promise<Columns> {
             try {
                 return await this.columnsService.getColumnById(columnsreq.columnsId);
             } catch (err) {
                 throw err;
             }
         }


         @Post('/getColumnsForZoneLevelRackId')
         async getColumnsForZoneLevelRackId(@Body() zoneRackLevelIdReq:ZoneRackLevelByIdDto): Promise<ColumnsDropDownResponseModel> {
             try {
              return await this.columnsService.getColumnsForZoneLevelRackId(zoneRackLevelIdReq);
            } catch (error) {
                 return this.applicationExceptionHandler.returnException(ColumnsDropDownResponseModel, error);
            }
          }
    
    
}
